import { IChartContainer } from "../../models/base/chart-container.interface";
import { TiChartMenuContainer } from "../../ti-chart-menu.container";
import { IComponent } from "../component.interface";
import { IndicatorLastPriceComponent } from "../indicators-last-price.component";
import { TiChartSeriesComponent } from "../ti-chart-series.component";

export class HighChartIndicatorsComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private tiChartMenuContainer: TiChartMenuContainer;
    private base: IChartContainer;

    constructor(el: HTMLElement, tiChartMenuContainer: TiChartMenuContainer, base: IChartContainer) {
        this.element = el;

        this.tiChartMenuContainer = tiChartMenuContainer;
        this.base = base;
        this.onIndicatorIconClick();
    }
    
    public toggle(show: boolean) {
        if (show) {
            this.element.removeClass('hidden');
        } else {
            this.element.addClass('hidden');
        }
    }

    private onIndicatorIconClick() {
        this.element.addEventListener('click', (ev: any) => {
            this.toggleIndicator(ev);
        });

        const allOptions = this.element.querySelectorAll<HTMLElement>('.tf');
        allOptions.forEach((op: HTMLElement) => {
            op.addEventListener('click', (ev: any) => {
                ev.stopPropagation();
                this.selectHighChartIndicator(op);
            });
        });
    }

    private selectHighChartIndicator(op: HTMLElement) {
        if (!op) { return; }
        const value = parseInt(op.dataset.value, 10);
        const mainChartSeries = this.base.getComponentsByType(TiChartSeriesComponent)[0] as TiChartSeriesComponent;
        if (!op.classList.contains('active')) {
            op.classList.add('active');
            mainChartSeries?.addHighChartIndicator(value);
        } else {
            op.classList.remove('active');
            mainChartSeries?.removeHighChartIndicator(value);
        }

        let indicatorLastPriceComponent = this.base.getComponentsByType(IndicatorLastPriceComponent)[0] as IndicatorLastPriceComponent
        indicatorLastPriceComponent.createLastPriceForIndicators();

        this.tiChartMenuContainer.closeAllMenuControls();
    }

    public toggleIndicator(ev: any) {
        ev.stopPropagation();

        this.tiChartMenuContainer.displayChartType = false;
        this.tiChartMenuContainer.displayTimeframe = false;
        this.tiChartMenuContainer.displayIndicator = !this.tiChartMenuContainer.displayIndicator;
        this.tiChartMenuContainer.displayTools = false;
        this.tiChartMenuContainer.toggleControls();
    }
}
